export const SESSION_TOKEN_KEY = 'SESSION_TOKEN';

export const TYPE = 't';